import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthenticatedUser {
  id: number;
  email: string;
}

interface AuthState {
  user: AuthenticatedUser | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoginState(state, action: PayloadAction<{ user: AuthenticatedUser }>) {
      state.user = action.payload.user;
      state.isAuthenticated = true;
    },
    setLogoutState(state) {
      state.user = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setLoginState, setLogoutState } = authSlice.actions;

export default authSlice.reducer;
